import { API } from 'aws-amplify';

export const UpdateMenu = (body:any) =>
{
	return API.put('departments', '/updateMenu', { body });
};

export const GetMenu = (queryStringParameters:any) =>
{
	return API.get('departments', '/getMenu', { queryStringParameters });
};
export const GetSideMenu = (queryStringParameters:any) =>
{
	return API.get('departments', '/sidemenu', { queryStringParameters });
};

export const CreateCustomMenu = (body:any) =>
{
	return API.post('departments', '/createMenu', { body });
};

export const DeleteCustomMenu = (id:any) =>
{
	return API.del('departments', `/deleteMenu/${id}`, {});
};